import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["name", "id", "disabled", "value", "aria-describedby", "aria-label"]
const _hoisted_2 = {
  key: 0,
  value: ""
}
const _hoisted_3 = ["value"]
const _hoisted_4 = ["id"]

import { toRef } from "vue";

export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'Select',
  props: {
    type: {
        type: String,
        default: "text",
        required: false,
    },
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [String, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    selectText: {
        type: String,
        required: false,
    },
    maxLength: {
        type: Number,
        default: null,
    },
    items: {
        type: Array,
    },
    ariaLabel: {
        type: String,
        default: null,
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {


const props = __props;

const emit = __emit;

const name = toRef(props, "name");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("select", {
      name: name.value,
      id: name.value,
      class: _normalizeClass(["form-select", {'is-invalid': !!__props.error}]),
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value))),
      disabled: __props.disabled,
      value: __props.modelValue,
      "aria-describedby": __props.error ? `${name.value}-error` : null,
      "aria-label": __props.ariaLabel || undefined
    }, [
      (__props.selectText)
        ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(__props.selectText), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          value: item.value,
          key: item.value
        }, _toDisplayString(item.text), 9, _hoisted_3))
      }), 128))
    ], 42, _hoisted_1),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          id: `${name.value}-error`,
          class: "invalid-feedback",
          role: "alert"
        }, _toDisplayString(__props.error), 9, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})